import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { IStrapiEntity } from '@core/interfaces/strapi.interface';
import { Bind } from '@noda-lib/utils/decorators';
import { ArticleAuthorImports } from '@pages/articles/article-page/author/article-author.imports';
import { IAuthor } from '@pages/articles/interfaces/article.interface';

@Component({
  selector: 'noda-article-author',
  templateUrl: './article-author.component.html',
  styleUrls: ['./article-author.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: ArticleAuthorImports,
})
export class ArticleAuthorComponent {
  public author: InputSignal<IStrapiEntity<IAuthor>> = input<IStrapiEntity<IAuthor>>();
  public reviewer: InputSignal<IStrapiEntity<IAuthor>> = input<IStrapiEntity<IAuthor>>();
  public articleModified: InputSignal<Date> = input<Date>();

  @Bind()
  public getImageUrl(person: IAuthor): string {
    return person.image.data.attributes.url;
  }

  @Bind()
  public getLink(person: IAuthor): string {
    return person.link;
  }

  @Bind()
  public getName(person: IAuthor): string {
    return person.name;
  }

  @Bind()
  public getProfession(person: IAuthor): string {
    return person.profession;
  }
}
